import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 27DE61C6-7B1F-429C-A396-AF9895CE5AD0
 * name view-carousel-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-carousel-outline.svg
 * tags
 * - View 
 */
export const ViewCarouselOutlineIcon = createSvgIcon(<><path d="M2 6H6V17H2V6M7 19H17V4H7V19M9 6H15V17H9V6M18 6H22V17H18V6Z" /></>, 'ViewCarouselOutlineIcon');
export default ViewCarouselOutlineIcon